import permissions from '../permission-list'

export default [
  {
    path: '/v2/banners',
    name: 'banners-v2',
    component: () => import('@/views/v2/Banners.vue'),
    meta: {
      pageTitle: 'Daftar Banner',
      resource: permissions.bannerV2,
      action: 'read',
      navActiveLink: 'banners-v2',
      localstorage: {
        query: 'banners-v2-query',
      },
      breadcrumb: [
        {
          text: 'Banner',
          active: true,
        },
      ],
    },
  },
  {
    path: '/v2/banners/create',
    name: 'banners-v2-create',
    component: () => import('@/views/v2/BannerCreate.vue'),
    meta: {
      pageTitle: 'Buat Banner',
      resource: permissions.bannerV2,
      action: 'manage',
      navActiveLink: 'banners-v2',
      breadcrumb: [
        { text: 'Banner', to: { name: 'banners-v2' } },
        { text: 'Buat', active: true },
      ],
    },
  },
  {
    path: '/v2/banners/:id/edit',
    name: 'banners-v2-edit',
    component: () => import('@/views/v2/BannerEdit.vue'),
    meta: {
      pageTitle: 'Edit Banner',
      resource: permissions.bannerV2,
      action: 'manage',
      navActiveLink: 'banners-v2',
      breadcrumb: [
        { text: 'Banner', to: { name: 'banners-v2' } },
        { text: 'Edit', active: true },
      ],
    },
  },
  {
    path: '/v2/banners/:id/detail',
    name: 'banners-v2-detail',
    component: () => import('@/views/v2/BannerDetail.vue'),
    meta: {
      pageTitle: 'Detail Banner',
      resource: permissions.bannerV2,
      action: 'read',
      navActiveLink: 'banners-v2',
      breadcrumb: [
        { text: 'Banner', to: { name: 'banners-v2' } },
        { text: 'Detail', active: true },
      ],
    },
  },
]
